import PersonService from "@/app/services/PersonService.js"
import { types } from "@/app/types/types";
import { importPersonsAndGroupsModeEnum } from "@/app/enums/common";

const state =
{
	[types.STATE_PERSONS]: []
};

const getters =
{
	[types.GET_PERSONS]: (state) =>
	{
		return state[types.STATE_PERSONS]
	},

	[types.GET_PERSON]: (state) => id =>
	{
		var persons = state[types.STATE_PERSONS];

		for (const person of persons)
		{
			if (person.id == id)
				return person;
		}

		return null;
	}
};

const mutations =
{
	[types.MUTATE_LOAD_PERSONS]: (state, payload) =>
	{
		// TODO: Do paging here
		state[types.STATE_PERSONS] = payload
	},

	[types.MUTATE_ADD_PERSON]: (state, payload) =>
	{
		state[types.STATE_PERSONS].push(payload);
	},

	[types.MUTATE_UPDATE_PERSON]: (state, payload) =>
	{
		//let index = state[types.STATE_PERSONS].findIndex(person => person.id == payload.id)
		//state[types.STATE_PERSONS].splice(index, 1, payload)
		let person = state[types.STATE_PERSONS].find((person) => { return person.id == payload.id });

		if (person)
		{
			person = payload
		}
	},

	[types.MUTATE_DELETE_PERSON]: (state, payload) =>
	{
		//let index = state[types.STATE_PERSONS].findIndex(person => person.id == payload.id)
		//state[types.STATE_PERSONS].splice(index, 1)
		state[types.STATE_PERSONS] = state[types.STATE_PERSONS].filter((person) => { return person.id !== payload });
	}
};

const actions =
{
	[types.ACTION_GET_PERSONS]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_GET_PERSONS, payload: payload })
		
		return PersonService.getPersons(payload).then(response =>
		{
			commit(types.MUTATE_LOAD_PERSONS, response.data);
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_GET_PERSONS, message: error, payload: payload });
			return error.response
		});
	},

	[types.ACTION_GET_PERSON]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_GET_PERSON, payload: payload })

		return PersonService.getPerson(payload).then(response =>
		{
			commit(types.MUTATE_UPDATE_PERSON, response.data);
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_GET_PERSON, message: error });
			return error.response
		});
	},

	[types.ACTION_ADD_PERSON]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_ADD_PERSON, payload: payload })

		return PersonService.addPerson(payload).then(response =>
		{
			commit(types.MUTATE_ADD_PERSON, response.data);
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_ADD_PERSON, message: error.response.statusText, payload: payload });
			return error.response
		});
	},

	[types.ACTION_UPDATE_PERSON]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_UPDATE_PERSON, payload: payload })

		return PersonService.updatePerson(payload).then(response =>
		{
			commit(types.MUTATE_UPDATE_PERSON, response.data);
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_UPDATE_PERSON, message: error.response.statusText, payload: payload });
			return error.response
		});
	},

	[types.ACTION_DELETE_PERSON]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_DELETE_PERSON, payload: payload })

		return PersonService.deletePerson(payload).then(response =>
		{
			commit(types.MUTATE_DELETE_PERSON, payload);
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_DELETE_PERSON, message: error.response.statusText, payload: payload });
			return error.response
		});
	},

	[types.ACTION_IMPORT_PERSONS_AND_GROUPS_VALIDATE_FILE]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_IMPORT_PERSONS_AND_GROUPS_VALIDATE_FILE, payload: payload })

		let action = importPersonsAndGroupsModeEnum.VALIDATE
		
		return PersonService.importPersonsAndGroups(payload.customerid, payload.agreementid, action, payload.formdata).then(response =>
		{
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_IMPORT_PERSONS_AND_GROUPS_VALIDATE_FILE, message: error.response.statusText, payload: payload });
			return error.response
		});
	},

	[types.ACTION_IMPORT_PERSONS_AND_GROUPS_IMPORT_FILE]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_IMPORT_PERSONS_AND_GROUPS_IMPORT_FILE, payload: payload })

		let action = importPersonsAndGroupsModeEnum.IMPORT

		return PersonService.importPersonsAndGroups(payload.customerid, payload.agreementid, action, payload.formdata).then(response =>
		{
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_IMPORT_PERSONS_AND_GROUPS_IMPORT_FILE, message: error.response.statusText, payload: payload });
			return error.response
		});
	},

	[types.ACTION_UPDATE_PERSON_MEDIAFILES]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_UPDATE_PERSON_MEDIAFILES, payload: payload })

		return PersonService.updatePersonMediaFiles(payload).then(response =>
		{
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_UPDATE_PERSON_MEDIAFILES, message: error.response.statusText, payload: payload })
			return error.response
		})
	},

	[types.ACTION_RESETPERSON_STATUS]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_RESETPERSON_STATUS, payload: payload })

		return PersonService.resetPersonStatus(payload).then(response =>
		{
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_RESETPERSON_STATUS, message: error.response.statusText, payload: payload })
			return error.response
		})
	}
}

export default
	{
		state,
		mutations,
		actions,
		getters
	}
